/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
import * as Papa from 'papaparse';

const CsvService = {
  readUsersFromCsv(file) {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        skipEmptyLines: true,
        complete(results) {
          let users = [];

          if (results.data) {
            users = results.data.map(row => {
              let email = row[0] || '';
              let displayName = row[1] || '';
              let password = row[2] || '';

              return {email, password, displayName, roles: []}
            });
          }

          resolve(users);
        },
        error(error) {
          reject(error);
        }
      });
    });
  }
}

export {
  CsvService
}